import "./Directives.scss";
import {tfVisible, TfVisible} from "./Visible";
import {touchEventFix, TouchEventFix} from "./TouchEventFix";
import {inputNumberFormat, InputNumberFormat} from "./format/InputNumberFormat";
import {clickCapture, ClickCapture} from "./ClickCapture";
import {slimScroll, SlimScroll} from "./slim-scroll/SlimScrollDirective";
import {timeAgo, TimeAgo} from "./time-ago/TimeAgoDirective";
import {inputScrollBlock, InputScrollBlock} from "./input-scroll-block/InputScrollBlockDirective";

export default angular.module("tfApp.tf-directives", [])
                      .directive(ClickCapture, clickCapture)
                      .directive(TfVisible, tfVisible)
                      .directive(TouchEventFix, touchEventFix)
                      .directive(InputNumberFormat, inputNumberFormat)
                      .directive(InputScrollBlock, inputScrollBlock)
                      .directive(SlimScroll, slimScroll)
                      .directive(TimeAgo, timeAgo)
                      .name;
